import { render, staticRenderFns } from "./souvenirList.vue?vue&type=template&id=357ed775&scoped=true"
import script from "./souvenirList.vue?vue&type=script&lang=js"
export * from "./souvenirList.vue?vue&type=script&lang=js"
import style0 from "./souvenirList.vue?vue&type=style&index=0&id=357ed775&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ed775",
  null
  
)

export default component.exports